import { useEffect, useRef } from "react";
import { device } from "web_myplann/Utils/device";

let pendingColor: string | undefined;

const requestStatusBarColor = (color: string) => {
	const isFlushScheduled = pendingColor !== undefined;
	pendingColor = color;
	if (isFlushScheduled) {
		return;
	}
	queueMicrotask(() => {
		const nextColor = pendingColor ?? "";
		pendingColor = undefined;
		device.changeDashboardColor(nextColor).catch(() => {});
	});
};

export const useDashboardStatusBarColor = (color: string | undefined) => {
	const colorRef = useRef(color);
	colorRef.current = color;

	useEffect(() => {
		if (color === undefined && document.visibilityState === "hidden") {
			return;
		}
		requestStatusBarColor(color ?? "");
	}, [color]);

	useEffect(() => {
		const restore = () => {
			if (document.visibilityState === "visible") {
				requestStatusBarColor(colorRef.current ?? "");
			}
		};
		document.addEventListener("visibilitychange", restore);
		window.addEventListener("pageshow", restore);

		return () => {
			requestStatusBarColor("");
			document.removeEventListener("visibilitychange", restore);
			window.removeEventListener("pageshow", restore);
		};
	}, []);
};
